// ─── Anpassen! ────────────────────────────────────────────────────────────────

// Deine HeyForm-Instanz und Form-ID
export const HEYFORM_BASE_URL = 'https://forms.openhousetheatre.at';
export const HEYFORM_FORM_ID  = 'U7eLnkYp';

// n8n Webhook: GET ?cid=<correlation_id>
// Antwort: { stripeUrl: string } | { status: 'pending' } | { status: 'paid' }
export const N8N_STATUS_WEBHOOK = 'https://infra.openhousetheatre.at/n8n/webhook/3f3cab7f-bcc9-42d6-a404-ad87f2c4c4cd';

// Stripe success_url – {CHECKOUT_SESSION_ID} wird von Stripe ersetzt
export const STRIPE_SUCCESS_URL = `${window.location.origin}/waiting?session_id={CHECKOUT_SESSION_ID}&cid=CID_PLACEHOLDER`;
// Hinweis: CID_PLACEHOLDER wird zur Laufzeit in WaitingPage durch die echte cid ersetzt,
// bevor die URL an n8n/Stripe übergeben wird.

// Polling-Intervall in ms
export const POLL_INTERVAL_MS = 2000;

// Maximale Wartezeit bis Timeout (ms)
export const POLL_TIMEOUT_MS  = 60_000;
